import { updateAccessToken } from '../shared-api/api'
import {
  getRefreshToken,
  setAccessToken,
  setExprireTokenIn,
  setRefreshToken,
} from '../shared-constants/localstorage'
export const checkExpireInToken = async (expireTime = 0) => {
  return new Promise(async (resolve, reject) => {
    try {
      const expireTokenTime = expireTime
      const currentDate = new Date().getTime() + 1000
      const refreshToken = getRefreshToken()
      if (refreshToken && currentDate > expireTokenTime) {
        const response = await updateAccessToken({ refreshToken })
        const { expireTime, accessToken } = setAuthInformation(
          response?.data.refreshToken,
          response?.data.accessToken,
          response?.data.expiresIn,
        )
        resolve({
          expireTime,
          accessToken,
          refreshToken: response?.refreshToken,
        })
      } else {
        reject('not need to update')
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 *
 * @param {number} expiresIn - the expiresIn time that recieve from api.
 * @returns {number} the calcute time.
 */

export const calcuteExpireTime = (expiresIn: string) => {
  const expireTokenIn = new Date()
  return expireTokenIn.getTime() + +expiresIn * 1000
}

export const setAuthInformation = async (
  refreshToken,
  accessToken,
  expiresIn,
) => {
  setRefreshToken(refreshToken)
  setAccessToken(accessToken)
  const expireTime = calcuteExpireTime(expiresIn)
  setExprireTokenIn(expireTime)
  return { expireTime, accessToken, refreshToken }
}
